















































import {Vue, Component, Prop, Ref} from "vue-property-decorator";
import {IPhoneNumber} from '@/models/IPhoneNumber.js';

@Component({
  name: "InputTelephone",
  components: {
  },
})
export default class InputTelephone extends Vue {
  @Prop({ default: '' })
  private telephone!: string; // v-model
  @Prop({ default: '' })
  private defaultNumber!: string;

  @Ref()
  private readonly vuePhoneNumberDom!: HTMLElement;

  private readonly buttonSetArray: Array<Array<(string|number)>> = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [0]];
  private readonly ignoredCountries: string[] = ['AS', 'AG', 'AI', 'BS', 'BB', 'BM', 'VG', 'GU', 'GD', 'JM',
    'MS', 'MP', 'KN', 'LC', 'VC', 'SX', 'VI', 'TC', 'TT', 'KY', 'DM'];
  // countries with telephone code too long that will give always prefix +1.
  private countrySelectorInput?: HTMLInputElement;
  private phoneNumber: string = ""; // what we show in the input

  private created() {
    window.addEventListener('keydown', this.processKey);
  }

  private mounted() {
    this.vuePhoneNumberDom.getElementsByClassName("input-tel__input")[0].setAttribute("readonly", "readonly");
    this.countrySelectorInput = this.vuePhoneNumberDom
                                    .getElementsByClassName("country-selector__input")[0] as HTMLInputElement;
    // disables the text input so we can only use the screen buttons
    this.phoneNumber = this.defaultNumber;
  }

  private destroyed() {
    window.removeEventListener('keydown', this.processKey);
  }

  private getTelephoneExtension() {
    return this.countrySelectorInput ? this.countrySelectorInput.value : "+34";
  }

  private processKey(event: KeyboardEvent ) {
    let key: string | number = event.key || event.keyCode;

    if (event.key === 'Backspace') {
      this.deleteLastNumber();
    } else {
      key = typeof key === "string" ? parseInt(key, 10) : key;

      if (key >= 0 && key <= 9) {
        this.buttonPress(key);
      }
    }
  }

  private updatePhoneData() {
    const telNumber: IPhoneNumber = {
      extension: this.getTelephoneExtension(),
      number: this.phoneNumber,
    };

    this.$emit('input', telNumber);
  }

  private buttonPress(myNumber: number|string) {
    if (typeof myNumber === "number" && this.phoneNumber.length <= 10) {
      this.phoneNumber = this.phoneNumber.match(/([0-9][0-9][0-9])$/) ? `${ this.phoneNumber } ${ myNumber }`
                                                                      : `${ this.phoneNumber }${ myNumber }`;
      this.updatePhoneData();
    }
  }

  private deleteLastNumber() {
    this.phoneNumber = this.phoneNumber.match(/( )$/) ? this.phoneNumber.slice(0, -2)
      : this.phoneNumber.slice(0, -1);
    this.updatePhoneData();
  }
}
